import PenIcon from "./PenIcon.mjs";

/** @type {GlyphIcon} */
export default PenIcon;